import React from 'react'
import { Card } from './Card'

interface SectionCardProps {
  title: string; description?: string; children: React.ReactNode; action?: React.ReactNode; style?: React.CSSProperties
}

export const SectionCard: React.FC<SectionCardProps> = ({ title, description, children, action, style }) => (
  <Card style={{ marginTop: '1rem', ...style }}>
    <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '1rem', marginBottom: description || children ? '1rem' : 0 }}>
      <div>
        <div style={{ fontSize: '0.95rem', fontWeight: 700, color: 'var(--text-primary)', marginBottom: description ? '0.2rem' : 0 }}>{title}</div>
        {description && (<div style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>{description}</div>)}
      </div>
      {action && <div style={{ flexShrink: 0 }}>{action}</div>}
    </div>
    {children}
  </Card>
)
